import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import LogInForm from '../forms/LogInForm'
import * as apiActions from 'api-actions'
import { useSubmitMessages } from 'utils'
import { useHistory } from 'react-router-dom'
import { LOGIN_TYPE } from 'types'

const propTypes = {
  authenticateUser: PropTypes.func.isRequired,
}
const defaultProps = {}

function Login({ authenticateUser }) {
  const history = useHistory()
  const { displaySubmitSuccess, displaySubmitFailure } = useSubmitMessages()

  return (
    <>
      <div className="login-content">
        <h1>Log In</h1>

        <LogInForm
          initialValues={{
            email: '',
            password: '',
            pin: '',
          }}
          onSubmit={async (params) => {
            const { loginType, ...formParams } = params

            try {
              await authenticateUser(formParams, loginType)
              await displaySubmitSuccess('Succesfully logged in.')
              const landingPath =
                loginType === LOGIN_TYPE.MANAGER ? '/manager' : '/'
              history.replace(landingPath)
            } catch (error) {
              // The error returned here is an API HTTPError object, that should have an errors key on it
              const errors = error.errors
              displaySubmitFailure(errors, null, error)
            }
          }}
        />
      </div>
    </>
  )
}

Login.propTypes = propTypes
Login.defaultProps = defaultProps

function mapStateToProps() {
  return {}
}

const mapDispatchToProps = {
  authenticateUser: apiActions.authenticateUser,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(Login)
